import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Settings.css';
import { globals } from "../globals";
import { useSettings } from '../context/SettingsContext';

const handleCleanDownloads = async () => {
  if (window.confirm('Sei sicuro di voler pulire file e token scaduti?')) {
    try {
      const response = await fetch(`${globals.homepageUrl}/php/clean-downloads.php`, {
        method: 'POST',
      });
      const result = await response.json();
      if (result.success) {
        alert('Pulizia completata!');
      } else {
        alert('Errore durante la pulizia.');
      }
    } catch (error) {
      alert('Errore nella richiesta.');
    }
  }
};

const handleGenerateSitemap = async () => {
  if (window.confirm('Vuoi rigenerare la sitemap?')) {
    try {
      const response = await fetch(`${globals.homepageUrl}/php/generate-sitemap.php`);
      const result = await response.json();
      if (result.success) {
        alert('Sitemap generata con successo!');
      } else {
        alert('Errore durante la generazione della sitemap.');
      }
    } catch (error) {
      alert('Errore nella richiesta.');
    }
  }
};


export default function Settings() {
  const [isSaving, setIsSaving] = useState(false);
  const { settings, setSettings, loading } = useSettings();
  const [localSettings, setLocalSettings] = useState(settings);

  useEffect(() => {
    setLocalSettings(settings); // Sync iniziale
  }, [settings]);

  // Il loading è gestito direttamente dal contesto ora
  if (loading) return <div>Caricamento...</div>;

  const handleSave = () => {
    setIsSaving(true);
    setSettings(localSettings); // Propaga al contesto globale

    axios.post(`${globals.homepageUrl}/php/settings.php`, {
      disable_site: localSettings.disableSite ? '1' : '0',
      show_slider: localSettings.showSlider ? '1' : '0',
      enable_ecommerce: localSettings.enableEcommerce ? '1' : '0',
      enable_antitheft: localSettings.enableAntitheft ? '1' : '0',
      galleries_in_homepage: localSettings.galleriesInHomepage,
      single_photo_price: localSettings.singlePhotoPrice,
      theme: localSettings.theme,
      language: localSettings.language,
    })
      .then(() => {
        alert('Salvato con successo!');
        setIsSaving(false);
      })
      .catch(() => {
        alert('Errore nel salvataggio.');
        setIsSaving(false);
      });
  };

  return (
    <div className="settings-container">
      <h1 className="settings-title">Pannello di amministrazione</h1>

      {/* chiusura sito */}
      <div className="settings-option">
        <input
          type="checkbox"
          id="close_site"
          checked={localSettings.disableSite}
          onChange={(e) =>
            setLocalSettings(prev => ({
              ...prev,
              disableSite: e.target.checked
            }))
          }
          className="settings-checkbox"
        />
        <label htmlFor="disable_site" className="settings-label">
          Chiusura sito
        </label>
      </div>

      {/* show slider */}
      <div className="settings-option">
        <input
          type="checkbox"
          id="show_slider"
          checked={localSettings.showSlider}
          onChange={(e) =>
            setLocalSettings(prev => ({
              ...prev,
              showSlider: e.target.checked
            }))
          }
          className="settings-checkbox"
        />
        <label htmlFor="show_slider" className="settings-label">
          Abilita slider
        </label>
      </div>

      {/* e-commerce */}
      <div className="settings-option">
        <input
          type="checkbox"
          id="enable_ecommerce"
          checked={localSettings.enableEcommerce}
          onChange={(e) =>
            setLocalSettings(prev => ({
              ...prev,
              enableEcommerce: e.target.checked
            }))
          }
          className="settings-checkbox"
        />
        <label htmlFor="enable_ecommerce" className="settings-label">
          Abilita funzionalità E-commerce
        </label>
      </div>

      {/* anti-theft */}
      <div className="settings-option">
        <input
          type="checkbox"
          id="enable_antitheft"
          checked={localSettings.enableAntitheft}
          onChange={(e) =>
            setLocalSettings(prev => ({
              ...prev,
              enableAntitheft: e.target.checked
            }))
          }
          className="settings-checkbox"
        />
        <label htmlFor="enable_antitheft" className="settings-label">
          Abilita funzionalità antifurto immagini
        </label>
      </div>

      {/* numero miniature in homepage */}
      <div className="settings-option">
        <label htmlFor="galleries_in_homepage" className="settings-label">
          Miniature in pagina principale:
        </label>
        <input
          type="number"
          id="galleries_in_homepage"
          value={localSettings.galleriesInHomepage}
          onChange={(e) =>
            setLocalSettings(prev => ({
              ...prev,
              galleriesInHomepage: e.target.value
            }))
          }
          className="settings-input"
        />
      </div>

      {/* Prezzo singola foto */}
      <div className="settings-option">
        <label htmlFor="single_photo_price" className="settings-label">
          Prezzo singola foto:
        </label>
        <input
          type="number"
          id="single_photo_price"
          value={localSettings.singlePhotoPrice}
          onChange={(e) =>
            setLocalSettings(prev => ({
              ...prev,
              singlePhotoPrice: e.target.value
            }))
          }
          className="settings-input"
        />
      </div>

      {/* esempio */}
      <div className="settings-option">
        <label htmlFor="theme" className="settings-label">
          Tema:
        </label>
        <select
          id="theme"
          value={localSettings.theme}
          onChange={(e) =>
            setLocalSettings(prev => ({
              ...prev,
              theme: e.target.value
            }))
          }
          className="settings-select"
        >
          <option value="light">Chiaro</option>
          <option value="dark">Scuro</option>
        </select>
      </div>

      {/* lingua */}
      <div className="settings-option">
        <label htmlFor="language" className="settings-label">
          Lingua:
        </label>
        <select
          id="language"
          value={settings.language}
          onChange={(e) =>
            setLocalSettings(prev => ({
              ...prev,
              language: e.target.value
            }))
          }
          className="settings-select"
        >
          <option value="it">Italiano</option>
          <option value="en">English</option>
        </select>
      </div>

      <div style={{ display: "flex", justifyContent: "space-evenly", gap: "1rem", marginTop: "20px" }}>
        <button
          onClick={handleSave}
          className="settings-button"
          disabled={isSaving}
        >
          {isSaving ? 'Salvataggio in corso...' : 'Salva'}
        </button>

        <button onClick={handleCleanDownloads} className="settings-button">
          Pulisci file e token scaduti
        </button>

        <button onClick={handleGenerateSitemap} className="settings-button">
          Genera sitemap
        </button>
      </div>

    </div>
  );
}
